import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { NoIndex } from '@sorare/core/src/contexts/seo';
import { useTitleAndDescription } from '@sorare/core/src/hooks/useTitleAndDescription';
import { createCardSorts } from '@sorare/core/src/lib/algolia';
import { metadatas } from '@sorare/core/src/lib/seo/football';
import { CardPageSearch } from '@sorare/marketplace/src/components/market/CardPageSearch';
import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import {
  backendLeaguePageFilters,
  leaguePageFilters,
} from '@sorare/marketplace/src/searchCards/football/cardFilters';

import { useLayoutData } from '#src/pages/leagues/$slug/layout.tsx';

const cardSorts = createCardSorts({
  withBestValue: true,
  withHighestAverageScore: true,
  withPopularPlayer: true,
});

const Cards = () => {
  const competition = useLayoutData();
  const filters = useDefaultFilters({
    leagueSlug: competition.slug,
  });

  useTitleAndDescription(
    metadatas.leagueCards.title,
    metadatas.leagueCards.description,
    {
      league: competition.name,
    }
  );

  return (
    <FullWidthContainer>
      <NoIndex />
      <CardPageSearch
        sport={Sport.FOOTBALL}
        sorts={cardSorts}
        defaultSort="Newly Listed"
        analyticsTags={['League', 'Football']}
        defaultFilters={filters}
        cardFilters={leaguePageFilters}
        backendCardFilters={backendLeaguePageFilters}
        topic={{ type: 'league', label: competition.name }}
      />
    </FullWidthContainer>
  );
};

export default Cards;
